/**
 * @author Fernando Ruano
 * @file actions.js
 * @description Role Actions
 */

// Constants
import {
  GET_ALL_ROLES,
  CREATE_ROLE,
  UPDATE_ROLE,
  GET_ROLE_BY_ID,
  DELETE_ROLE_BY_ID,
  CREATE_ROLE_PERMISSION,
  DELETE_ROLE_PERMISSION_BY_ID
} from './constants';

/**
 * Call process to get all roles list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALL_ROLES
 */
export const getRolesArray = (data, callback) => ({
  type: GET_ALL_ROLES,
  payload: { data },
  callback
});

/**
 * Call process to get role by id
 * @param  { object } data - Role Id
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ROL_BY_ID
 */
export const getRoleById = (data, callback) => ({
  type: GET_ROLE_BY_ID,
  payload: { data },
  callback
});

/**
 * Call process to create role
 * @param  { object } data - Role Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of CREATE_ROLE
 */
export const createRole = (data, callback) => ({
  type: CREATE_ROLE,
  payload: { data },
  callback
});

/**
 * Call process to update role
 * @param  { object } data - Role Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of UPDATE_ROLE
 */
export const updateRole = (data, callback) => ({
  type: UPDATE_ROLE,
  payload: { data },
  callback
});

/**
 * Call process to delete role
 * @param  { object } data - Role Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of DELETE_ROLE_BY_ID
 */
export const deleteRoleById = (data, callback) => ({
  type: DELETE_ROLE_BY_ID,
  payload: { data },
  callback
});

/**
 * Call process to create role permission
 * @param  { object } data - Role Permission Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of CREATE_ROLE_PERMISSION
 */
export const createRolePermission = (data, callback) => ({
  type: CREATE_ROLE_PERMISSION,
  payload: { data },
  callback
});

/**
 * Call process to delete role permission
 * @param  { object } data - Role permission Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of UPDATE_ROLE
 */
export const deleteRolePermissionById = (data, callback) => ({
  type: DELETE_ROLE_PERMISSION_BY_ID,
  payload: { data },
  callback
});
